import * as React from "react";
export const SvgSeparator = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={1} height={34} fill="none" {...props}>
		<path fill="#E7E7E7" d="M0 0h1v34H0z" />
	</svg>
);
